function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var __generator = this && this.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return(g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g);
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  && {\n    align-self: center;\n    margin-bottom: 1.5rem;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  && {\n    margin-bottom: 24px;\n    @media (max-width: 600px) {\n      flex-direction: row;\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n  svg {\n    margin-right: 8px;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  .ant-card .ant-card-body {\n    width: 634px;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "Minimum 8 characters"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "Contains 1 letter"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "Contains 1 number"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "Contains 1 special character"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "Successfully activated account."
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "Terms of Use"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "Privacy Policy"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _taggedTemplateLiteral([
        "Activate your Account"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _taggedTemplateLiteral([
        "Email Address"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _taggedTemplateLiteral([
        "Email cannot be changed. If you wish to use a different email, please contact your event organizer to update your profile email."
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = _taggedTemplateLiteral([
        "First Name"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = _taggedTemplateLiteral([
        "First Name is required."
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = _taggedTemplateLiteral([
        "Last Name"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = _taggedTemplateLiteral([
        "Last Name is required."
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = _taggedTemplateLiteral([
        "Password"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = _taggedTemplateLiteral([
        "Password is required."
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = _taggedTemplateLiteral([
        "Confirm New Password"
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = _taggedTemplateLiteral([
        "Password is required."
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = _taggedTemplateLiteral([
        "Passwords must match."
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = _taggedTemplateLiteral([
        "By activating your account you agree to our ",
        " and ",
        "."
    ]);
    _templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = _taggedTemplateLiteral([
        "Activating Account..."
    ]);
    _templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}
function _templateObject26() {
    var data = _taggedTemplateLiteral([
        "Activate Account"
    ]);
    _templateObject26 = function _templateObject26() {
        return data;
    };
    return data;
}
import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { useHistory } from "react-router-dom";
import { message, Form as AntForm, Typography, Input, Popover, Button } from "antd";
import { EyeInvisibleOutlined, EyeTwoTone, WarningFilled, CheckCircleFilled } from "@ant-design/icons";
import { t, jt } from "ttag";
import useSearchParams from "../../hooks/useSearchParams";
import Label from "../Label";
import Layout from "./Layout";
import useInvite from "./useInvite";
var AntTitle = Typography.Title, Paragraph = Typography.Paragraph;
var useForm = AntForm.useForm;
var ONE_LETTER_REGEX = /[a-zA-Z]/;
var ONE_NUMBER_REGEX = /[0-9]/;
var ONE_SPECIAL_CHARACTER_REGEX = /[ !"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]/;
var EIGHT_CHARACTERS_REGEX = /.{8}/;
var Title = styled(AntTitle)(_templateObject());
var Form = styled(AntForm)(_templateObject1());
var Field = styled(AntForm.Item)(_templateObject2());
var Check = styled.div(_templateObject3(), function(param) {
    var isValid = param.isValid;
    return isValid ? "#6EBB83" : "#ff4d4f";
});
var Wrapper = styled.div(_templateObject4());
var validatePassword = function(password) {
    var hasLetter = !!password.match(ONE_LETTER_REGEX);
    var hasNumber = !!password.match(ONE_NUMBER_REGEX);
    var hasSpecialCharacter = !!password.match(ONE_SPECIAL_CHARACTER_REGEX);
    var hasEightCharacters = !!password.match(EIGHT_CHARACTERS_REGEX);
    var isValid = password && hasLetter && hasNumber && hasSpecialCharacter && hasEightCharacters;
    return {
        hasLetter: hasLetter,
        hasNumber: hasNumber,
        hasSpecialCharacter: hasSpecialCharacter,
        hasEightCharacters: hasEightCharacters,
        isValid: isValid
    };
};
var PasswordCheck = function(param) {
    var children = param.children, isValid = param.isValid;
    return /*#__PURE__*/ React.createElement(Check, {
        isValid: isValid
    }, isValid && /*#__PURE__*/ React.createElement(CheckCircleFilled, null), !isValid && /*#__PURE__*/ React.createElement(WarningFilled, null), children);
};
var PasswordInstructions = function(param) {
    var password = param.password;
    var _validatePassword = validatePassword(password), hasEightCharacters = _validatePassword.hasEightCharacters, hasLetter = _validatePassword.hasLetter, hasNumber = _validatePassword.hasNumber, hasSpecialCharacter = _validatePassword.hasSpecialCharacter;
    return /*#__PURE__*/ React.createElement("div", {
        "data-testid": "passwordInstructions"
    }, /*#__PURE__*/ React.createElement(PasswordCheck, {
        isValid: hasEightCharacters
    }, t(_templateObject5())), /*#__PURE__*/ React.createElement(PasswordCheck, {
        isValid: hasLetter
    }, t(_templateObject6())), /*#__PURE__*/ React.createElement(PasswordCheck, {
        isValid: hasNumber
    }, t(_templateObject7())), /*#__PURE__*/ React.createElement(PasswordCheck, {
        isValid: hasSpecialCharacter
    }, t(_templateObject8())));
};
var PasswordField = function(_param) /*#__PURE__*/ {
    var value = _param.value, onChange = _param.onChange, showInstructions = _param.showInstructions, rest = _objectWithoutProperties(_param, [
        "value",
        "onChange",
        "showInstructions"
    ]);
    return React.createElement(Popover, {
        open: showInstructions,
        placement: "bottomLeft",
        content: /*#__PURE__*/ React.createElement(PasswordInstructions, {
            password: value
        })
    }, /*#__PURE__*/ React.createElement(Input.Password, _extends({
        value: value,
        "data-testid": "password",
        onChange: onChange
    }, rest)));
};
var visibilityIcon = function(visible) {
    return visible ? /*#__PURE__*/ React.createElement(EyeTwoTone, null) : /*#__PURE__*/ React.createElement(EyeInvisibleOutlined, null);
};
var ActivateAccount = function(param) {
    var id = param.id, token = param.token, _param_description = param.description, description = _param_description === void 0 ? "" : _param_description, checkInviteStatusFn = param.checkInviteStatusFn, acceptInviteFn = param.acceptInviteFn, onUserAlreadyActivated = param.onUserAlreadyActivated, onActivated = param.onActivated;
    var _useForm = _slicedToArray(useForm(), 1), form = _useForm[0];
    var validateFields = form.validateFields, getFieldValue = form.getFieldValue;
    var _useState = _slicedToArray(useState(false), 2), inputFocus = _useState[0], setInputFocus = _useState[1];
    var _useState1 = _slicedToArray(useState(false), 2), showPasswordPopup = _useState1[0], setShowPasswordPopup = _useState1[1];
    var history = useHistory();
    var query = useSearchParams();
    var _useInvite = useInvite(token, id, checkInviteStatusFn, acceptInviteFn), isValidating = _useInvite.isValidating, status = _useInvite.status, accept = _useInvite.accept, isAcceptInProgress = _useInvite.isAcceptInProgress;
    useEffect(function() {
        if (!isValidating && !(status === null || status === void 0 ? void 0 : status.isNewUser)) {
            onUserAlreadyActivated === null || onUserAlreadyActivated === void 0 ? void 0 : onUserAlreadyActivated();
        }
    }, [
        isValidating,
        status,
        history,
        onUserAlreadyActivated
    ]);
    var handleOnFocus = function() {
        setShowPasswordPopup(true);
        setInputFocus(true);
    };
    var handleOnBlur = function() {
        setShowPasswordPopup(false);
        setInputFocus(false);
    };
    var onFinish = function() {
        var _ref = _asyncToGenerator(function() {
            var _ref, firstName, lastName, password;
            return __generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            validateFields()
                        ];
                    case 1:
                        _ref = _state.sent(), firstName = _ref.firstName, lastName = _ref.lastName, password = _ref.password;
                        return [
                            4,
                            accept({
                                firstName: firstName,
                                lastName: lastName,
                                password: password
                            })
                        ];
                    case 2:
                        _state.sent();
                        message.success(t(_templateObject9()));
                        onActivated();
                        return [
                            2
                        ];
                }
            });
        });
        return function onFinish() {
            return _ref.apply(this, arguments);
        };
    }();
    var termsOfUseLink = /*#__PURE__*/ React.createElement("a", {
        key: "termsOfUseLink",
        href: "https://eventmobi.com/terms-of-use/",
        rel: "nofollow noopener noreferrer",
        target: "_blank"
    }, t(_templateObject10()));
    var privacyPolicyLink = /*#__PURE__*/ React.createElement("a", {
        key: "privacyPolicyLink",
        href: "https://eventmobi.com/privacy-policy/",
        rel: "nofollow noopener noreferrer",
        target: "_blank"
    }, t(_templateObject11()));
    if (isValidating || !status) {
        return null;
    }
    var _ref = [
        query.get("email"),
        query.get("first_name"),
        query.get("last_name")
    ], email = _ref[0], firstName = _ref[1], lastName = _ref[2];
    return /*#__PURE__*/ React.createElement(Wrapper, null, /*#__PURE__*/ React.createElement(Layout, null, /*#__PURE__*/ React.createElement(Form, {
        form: form,
        layout: "vertical",
        requiredMark: false,
        initialValues: {
            email: email,
            firstName: firstName,
            lastName: lastName,
            password: "",
            confirmPassword: ""
        },
        onFinish: onFinish
    }, /*#__PURE__*/ React.createElement(Title, {
        level: 4
    }, t(_templateObject12())), description && /*#__PURE__*/ React.createElement(Paragraph, {
        style: {
            textAlign: "center"
        }
    }, description), /*#__PURE__*/ React.createElement(Field, {
        label: /*#__PURE__*/ React.createElement(Label, null, t(_templateObject13())),
        name: "email",
        style: {
            marginBottom: 0
        }
    }, /*#__PURE__*/ React.createElement(Input, {
        disabled: true,
        "data-testid": "email"
    })), /*#__PURE__*/ React.createElement(Paragraph, {
        type: "secondary",
        style: {
            marginBottom: 24
        }
    }, t(_templateObject14())), /*#__PURE__*/ React.createElement(Field, {
        label: /*#__PURE__*/ React.createElement(Label, {
            isRequired: true
        }, t(_templateObject15())),
        name: "firstName",
        rules: [
            {
                required: true,
                message: t(_templateObject16())
            }
        ]
    }, /*#__PURE__*/ React.createElement(Input, {
        disabled: !!firstName,
        "data-testid": "firstName"
    })), /*#__PURE__*/ React.createElement(Field, {
        label: /*#__PURE__*/ React.createElement(Label, {
            isRequired: true
        }, t(_templateObject17())),
        name: "lastName",
        rules: [
            {
                required: true,
                message: t(_templateObject18())
            }
        ]
    }, /*#__PURE__*/ React.createElement(Input, {
        disabled: !!lastName,
        "data-testid": "lastName"
    })), /*#__PURE__*/ React.createElement(Field, {
        label: /*#__PURE__*/ React.createElement(Label, {
            isRequired: true
        }, t(_templateObject19())),
        name: "password",
        validateTrigger: [
            "onChange",
            "onFocus",
            "onBlur"
        ],
        rules: [
            {
                required: true,
                message: t(_templateObject20())
            },
            {
                validator: function(_, value) {
                    var isValid = validatePassword(value).isValid;
                    if (isValid) {
                        setShowPasswordPopup(false);
                        return Promise.resolve();
                    }
                    if (inputFocus) {
                        setShowPasswordPopup(true);
                    }
                    return Promise.reject(new Error(""));
                }
            }
        ]
    }, /*#__PURE__*/ React.createElement(PasswordField, {
        showInstructions: showPasswordPopup,
        onFocus: handleOnFocus,
        onBlur: handleOnBlur
    })), /*#__PURE__*/ React.createElement(Field, {
        label: /*#__PURE__*/ React.createElement(Label, {
            isRequired: true
        }, t(_templateObject21())),
        name: "confirmPassword",
        rules: [
            {
                required: true,
                message: t(_templateObject22())
            },
            {
                validator: function(_, value) {
                    if (!value || getFieldValue("password") === value) {
                        return Promise.resolve();
                    }
                    return Promise.reject(new Error(t(_templateObject23())));
                }
            }
        ]
    }, /*#__PURE__*/ React.createElement(Input.Password, {
        "data-testid": "confirmPassword",
        iconRender: visibilityIcon
    })), /*#__PURE__*/ React.createElement(Paragraph, null, jt(_templateObject24(), termsOfUseLink, privacyPolicyLink)), /*#__PURE__*/ React.createElement(Field, {
        shouldUpdate: true,
        noStyle: true
    }, function() {
        return /*#__PURE__*/ React.createElement(Button, {
            type: "primary",
            htmlType: "submit",
            disabled: isAcceptInProgress || !(getFieldValue("firstName") && getFieldValue("lastName") && getFieldValue("password") && getFieldValue("confirmPassword")),
            loading: isAcceptInProgress,
            style: {
                marginBottom: "16px"
            },
            "data-testid": "btnActivate"
        }, isAcceptInProgress ? t(_templateObject25()) : t(_templateObject26()));
    }))));
};
export default ActivateAccount;
